import { render, staticRenderFns } from "./Brigadas.vue?vue&type=template&id=0daa6684&"
import script from "./Brigadas.vue?vue&type=script&lang=js&"
export * from "./Brigadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports